enum Actions {
  // action types
  UPDATE_PASSWORD = "updatePassword",
  RESET_PASSWORD = "resetPassword",
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  IDLE_VUE_CHANGED = "idleVue/IDLE_CHANGED",
}

enum AssetsMutations {
  // mutation types
  SET_USERS = "setUsers",
  SET_USERS_VISITS = "setUsersVisits",
  SET_USERS_VISITS_WITH_ASSOCIATED_DONORS = "setUsersVisitsWithAssociatedDonors",
  SET_TERMINATION_REASONS = "setTerminationReasons",
  SET_STATES = "setStates",
  SET_TRANSPORTS = "setTransports",
  SET_COLLECTORS = "setCollectors",
  SET_ROLES = "setRoles",
  SET_ERROR = "setError",
  LOADING = "loading",
  SET_CLAIM_REASONS = "setClaimReasons",
  SET_REJECTION_REASONS_REQUEST = "setRejectionReasonsRequest",
  SET_PENDING_REQUEST = "setPendingRequests",
  CLEAR_PENDING_REQUEST = "clearPendingRequests",
}

enum AssetsActions {
  // action types
  GET_USERS = "getUsers",
  GET_USERS_VISITS = "getUsersVisits",
  GET_USERS_VISITS_WITH_ASSOCIATED_DONORS = "getUsersVisitsWithAssociatedDonors",
  GET_TERMINATION_REASONS = "getTerminationReasons",
  GET_STATES = "getStates",
  GET_TRANSPORTS = "getTransports",
  GET_COLLECTORS = "getCollectors",
  GET_ROLES = "getRoles",
  SET_LOADING = "setLoading",
  GET_CLAIM_REASONS = "getClaimReasons",
  GET_REJECTION_REASONS_REQUEST = "getRejectionReasonsRequest",
}

export { Actions, Mutations, AssetsMutations, AssetsActions };
